export default "__VITE_ASSET__c2b23a87__"